var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 374 352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0293d6",
    d: "M85 309a127 127 0 0 0 88 43 80 80 0 0 0 53-24 922 922 0 0 1 87-66l17-7c7-3 19-10 30-23 12-16 14-33 14-39a110 110 0 0 0-18-53A332 332 0 0 1 85 309z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebe638",
    d: "M123 25a80 80 0 0 1 58-25 52 52 0 0 1 38 13 174 174 0 0 0 98 32c9 1 27 4 39 19 9 12 10 25 10 31a139 139 0 0 1-10 45L123 25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bad147",
    d: "M85 309c-9-1-21-4-35-10s-31-13-42-32c-7-12-8-24-8-32a138 138 0 0 1 15-61 282 282 0 0 0 19-73l5-20c3-10 5-20 12-30l11-12a95 95 0 0 1 61-14 312 312 0 0 0-38 284z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#78b650",
    d: "M123 25c-1 0 54 3 88 15l28 12c-11-1-81-4-134 49-67 68-45 161-44 166a102 102 0 0 1-22-69 240 240 0 0 1 84-173z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f8260",
    d: "M257 272a200 200 0 0 0-18-220 137 137 0 0 1 76 40c12 10 27 25 41 48a295 295 0 0 1-99 132z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#085229",
    d: "M289 96c-16-27-39-39-49-44-8-2-83-14-140 41-46 44-49 101-49 112a171 171 0 0 0 36 104 238 238 0 0 0 90 0c15-3 50-9 80-35 4-4 48-45 51-110 0-11 0-39-19-68zm-36 145a99 99 0 0 1-73 32c-6 0-46-1-74-34-4-5-24-29-23-65 2-48 40-76 48-82 7-5 24-16 49-17 6-1 27-2 48 10 46 25 48 85 48 89 0 11 0 41-23 67z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdp);
export default __webpack_public_path__ + "static/media/usdp.371be1eca8bdf53bdd4938b72b778934.svg";
export { ForwardRef as ReactComponent };